/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['underscore'], function(_) {
    return {
        _cache: {},

        has: function(key) {
            return _.has(this._cache, key);
        },

        get: function(key) {
            return JSON.parse(this._cache[key]);
        },

        set: function(key, data) {
            this._cache[key] = JSON.stringify(data);
        }
    };
});
